export { default } from '@shikijs/langs/proto'
